// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en-US.js";
import cn from "./locales/zh-CN.js";

const resources = {
  en: {
    translation: en,
  },
  zh: {
    translation: cn,
  },
};

i18n
  .use(initReactI18next) // 注册
  .init({
    resources,
    lng: window.lang || "zh", // 默认语言
    interpolation: {
      escapeValue: false, // xss安全开关
    },
  });

export default i18n;
